import { render } from "./EmailViewers.vue?vue&type=template&id=a564e840&scoped=true"
import script from "./EmailViewers.vue?vue&type=script&lang=js"
export * from "./EmailViewers.vue?vue&type=script&lang=js"

import "./EmailViewers.vue?vue&type=style&index=0&id=a564e840&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a564e840"]])

export default __exports__